/* eslint-disable no-console -- patches console.* for on-device debug capture (Dev Settings) */
const MAX_LINES = 120

const lines: string[] = []
let installed = false

function formatArg(arg: unknown): string {
  if (arg instanceof Error) {
    return `${arg.name}: ${arg.message}`
  }
  if (typeof arg === 'string') return arg
  try {
    return JSON.stringify(arg)
  } catch {
    return String(arg)
  }
}

function pushLine(level: string, args: unknown[]): void {
  const time = new Date().toLocaleTimeString()
  const body = args.map(formatArg).join(' ')
  lines.push(`[${time}] [${level}] ${body}`)
  if (lines.length > MAX_LINES) {
    lines.splice(0, lines.length - MAX_LINES)
  }
}

/** Patches console methods to retain recent lines for on-device debugging (e.g. iPad). */
export function installDevConsoleCapture(): void {
  if (installed || typeof console === 'undefined') return
  installed = true

  const wrap =
    (level: 'log' | 'info' | 'warn' | 'error', original: (...args: unknown[]) => void) =>
    (...args: unknown[]) => {
      pushLine(level, args)
      original(...args)
    }

  console.log = wrap('log', console.log.bind(console))
  console.info = wrap('info', console.info.bind(console))
  console.warn = wrap('warn', console.warn.bind(console))
  console.error = wrap('error', console.error.bind(console))
}

export function getDevConsoleLines(): readonly string[] {
  return lines
}

export function clearDevConsoleLines(): void {
  lines.length = 0
}
